'use client';

import NextLink from 'next/link';
import { useLocale } from '@/app/[lang]/providers/LocaleProvider'
import { withLocale } from '@/lib/withLocale';
import React from 'react';

type Props = Omit<React.ComponentProps<typeof NextLink>, 'href'> & {
  href: string;
  localeOverride?: string; // optional override, e.g. "en" or "id"
};

/**
 * A wrapper around next/link that automatically prefixes the current locale.
 */
export function LocalizedLink({ href, children, localeOverride, ...rest }: Props) {
  const lang = useLocale();
  const effectiveLocale = localeOverride ?? lang;
  const localizedHref = withLocale(href, effectiveLocale);
  const prefetch = rest.prefetch ?? false;

  return (
    <NextLink href={localizedHref} prefetch={prefetch} {...rest}>
      {children}
    </NextLink>
  );
}